import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const courseOptions = ['A Letter From ADRE', 'Are They Represented?', 'Avoid The Oops: Contract Smarts for Agents', 'BMC #1 AZ Residential-Statutes and Rules', 'BMC #2 AZ Residential-Broker Policies', 'BMC #3 AZ Residential-Broker Supervision', 'BMC #3B Property Management', "Don't Lose Your License", 'Ethics & The Rules (with NAR Code of Ethics)', "Fair Housing In Today's World", 'Follow All The Laws', 'Mastering Agency Agreements', 'NAR Code of Ethics (NO CE CREDIT)', 'No Secrets', 'The Bottom Line of Disclosure', 'They Are A Protected Class', 'What Goes Wrong In Contracts', 'Your Clients Are Not Mushrooms'];
export function SwitchExpiredClass() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2444" data-mp="3iv1pqmoewj5">
      <div className="flex items-center justify-between" data-id="element-2445" data-mp="3i39mpsafgxm">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2446" data-mp="1yvylnkzvr1ys">
          Switch Expired Class
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-2447" data-mp="1twlxmwx9voum">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-2448" data-mp="1fxulhg1z0d94">
        <CardContent className="pt-6" data-id="element-2449" data-mp="1fxm5vgegqtu8">
          <form className="space-y-4" data-id="element-2450" data-mp="1fynl7x2ii2hr">
            <div className="flex items-center gap-3" data-id="element-2451" data-mp="1b6w0i361eqzj">
              <label className="text-sm font-medium text-slate-700 w-20" data-id="element-2452" data-mp="1b5ba8pqr9u7h">
                Old Class:
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[260px]" data-id="element-2453" data-mp="1656tcylxqxgq">
                {courseOptions.map(c => <option key={c} data-id="element-2454" data-mp="s7ru725vrbbk">{c}</option>)}
              </select>
            </div>
            <div className="flex items-center gap-3" data-id="element-2455" data-mp="ike6rw11vfgf">
              <label className="text-sm font-medium text-slate-700 w-20" data-id="element-2456" data-mp="iil0ihucmx8y">
                New Class:
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[260px]" data-id="element-2457" data-mp="mjem34kbjzyo">
                {courseOptions.map(c => <option key={c} data-id="element-2458" data-mp="dmw4gohjfyhe">{c}</option>)}
              </select>
            </div>
            <div className="pt-1" data-id="element-2459" data-mp="169qoxlecuxuv">
              <Button type="submit" data-id="element-2460" data-mp="16a08aq4wa6rl">Apply</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}